import { useTranslation } from "react-i18next";
import styles from "./usuallyKanaWord.module.scss";

type UsuallyKanaWordProps = {
    word: string;
    alsoWritten?: string;
    className?: string;
};

/** The JLPT data's primary form plus a compact JMdict usually-kana spelling. */
export default function UsuallyKanaWord({ word, alsoWritten, className }: UsuallyKanaWordProps) {
    const { t, i18n } = useTranslation("common");
    return (
        <span className={className} lang="ja">
            {word}
            {alsoWritten && alsoWritten !== word && (
                <small className={styles.alsoWritten} lang={i18n.language === "pt" ? "pt-PT" : "en"} aria-label={t("wordForms.alsoWritten", { word: alsoWritten })}>
                    {t("wordForms.alsoWritten", { word: alsoWritten })}
                </small>
            )}
        </span>
    );
}
